module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_19-2ce271a6b7d8b2ce59c6a0c68832106e.png";